import ApplyForm from '@components/sections/ApplyForm'
import styles from './GetInTouch.module.css'

const GetInTouch = () => {
  return (
    <div className={styles.getInTouch}>
      <ApplyForm />
    </div>
  )
}

export default GetInTouch
